const { log, formatDollars } = require("../std/index");

//
// Cart Quantity Widget
//
// Handles automatic cart updates when quantity inputs change
//

module.exports = class CartQuantityWidget {

  constructor($host, config) {
    this.config = config;

    this.dom = {
      input: $host,
      row: $host.closest('.cart-row')
    };

    this.state = {
      debounceTimeout: null,
      debounceDelay: 500,
      originalValue: parseInt($host.data('original-value')) || 1
    };

    this.init();
  }

  init() {
    this.dom.input.on('input', this.handleQuantityChange.bind(this));
  }

  handleQuantityChange(e) {
    const $input = $(e.target);
    const line = $input.data('line');
    const quantity = parseInt($input.val()) || 0;

    // Clear existing timeout
    if (this.state.debounceTimeout) {
      clearTimeout(this.state.debounceTimeout);
    }

    // Set new timeout
    this.state.debounceTimeout = setTimeout(() => {
      this.updateCartQuantity(line, quantity);
    }, this.state.debounceDelay);
  }

  updateCartQuantity(line, quantity) {
    // Show loading state
    this.dom.input.addClass('is-updating');

    // Make AJAX request to update cart
    $.ajax({
      url: '/cart/change.js',
      method: 'POST',
      data: {
        line: line,
        quantity: quantity
      },
      dataType: 'json',
      success: this.updateCartDisplay.bind(this),
      error: this.handleError.bind(this)
    });
  }

  updateCartDisplay(cart) {
    log('Cart updated:', cart);

    // Update cart count in header/navigation if it exists
    const $cartCount = $('.cart-count, [data-cart-count]');
    if ($cartCount.length) {
      $cartCount.text(cart.item_count);
    }

    // Update cart subtotal - use Shopify's money format
    const $cartTotal = $('[data-cart-total]');
    if ($cartTotal.length) {
      // Format money using Shopify's format (assuming USD for now)
      const formattedMoney = this.formatMoney(cart.total_price);
      $cartTotal.text(formattedMoney);
    }

    // If quantity is 0, remove the item from display
    if (this.dom.input.val() == 0) {
      this.dom.row.fadeOut(300, function() {
        $(this).remove();
      });
    }

    // Trigger custom event for other components
    $(document).trigger('cart:updated', [cart]);
  }

  handleError(xhr, status, error) {
    log('Error updating cart:', error);
    this.revertInputValue();
  }

  revertInputValue() {
    this.dom.input.val(this.state.originalValue);
  }

  formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      const moneyFormat = window.Shopify.money_format || '${{amount}}';
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return '$' + (cents / 100).toFixed(2);
  }
};
